import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const dataTableDispositivo = createSlice({
    name:'dialogDispositivo',
    initialState,
    reducers: {
        reloadingDataTable: (state) => { 
            return !state;
         }
    }
})

export const { reloadingDataTable  } = dataTableDispositivo.actions;

const { reducer } = dataTableDispositivo;

export default reducer;